import React, { useEffect } from "react";
import Breadcrumbs from "../../components/Breadcrumbs";
import "moment-timezone";

import Dashboard from "../../components/Dashboard";
import { authenticateAdminPage } from "../../lib/helpers/validation";

function AdminTransactions(props) {
  useEffect(() => {
    authenticateAdminPage(props);
  }, []);
  const linksList = [
    {
      title: "General Transactions",
      routeTo: "/general-transactions",
      icon: require("../../assets/images/dashboard-img1.png"),
    },
    {
      title: "Income Transactions",
      routeTo: "/income-transactions",
      icon: require("../../assets/images/dashboard-img2.png"),
    },
    {
      title: "Payment Transactions",
      routeTo: "/payment-transactions",
      icon: require("../../assets/images/dashboard-img4.png"),
    },
    {
      title: "Deduct/Add/Transfer Points",
      routeTo: "/manage-points",
      icon: require("../../assets/images/dashboard-img9.png"),
    },
  ];

  return (
    <main className="admin-dashboard">
      <div className="container custom-container">
        <Breadcrumbs
          size="text-large"
          placeholder="Transactions"
          targetLink="/admin-dashboard"
          hasButton="false"
          customClassName="m-3"
        />
        <Dashboard links={linksList} />
      </div>
    </main>
  );
}

export default AdminTransactions;
